import { render, staticRenderFns } from "./GoodsComposeForm.vue?vue&type=template&id=044bbaa2&"
import script from "./GoodsComposeForm.vue?vue&type=script&lang=js&"
export * from "./GoodsComposeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports